import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '1rem 0',
    width: '100%',
    '& > *': {
      margin: theme.spacing(0.5),
      textTransform: 'capitalize',
    },
    chip: {
      marginRight: '8px',
    },
  },
}));

// Sets which items in params to show in the filter display
const filterItems = [
  'service_location',
  'service',
  'search_text',
  'ndis_registered',
  'ndisec_registered',
  'specialisation',
  'age_group',
  'access_method',
];

const FilterDisplay = ({params, filterClose}) => {
  const classes = useStyles();

  // Extract presented filter items and form display text
  const filters = [];
  Object.keys(params).forEach(key => {
    if (filterItems.includes(key)) {
      if (params[key] !== null) {
        let filter = {};
        filter.key = key;
        filter[key] = params[key];
        filter.text = `${key.replace('_', ' ')}: ${params[key]}`;
        filters.push(filter);
      }
    }
  });

  // eslint-disable-next-line
  const handleClick = key => event => {
    filterClose(key);
  };

  if (filters.length === 0) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2" aria-label="Filters">Filters: </Typography>
      <React.Fragment>
        {filters.map(filter =>
          <Chip
            key={filter.key}
            label={filter.text}
            aria-label={filter.text}
            onDelete={handleClick(filter.key)}
            variant="outlined"
            color="primary"
            className={classes.chip}
          />
        )}
      </React.Fragment>
    </div>
  );
};

FilterDisplay.propTypes = {
  params: PropTypes.object,
  filterClose: PropTypes.func.isRequired,
};

export default FilterDisplay;
